import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useLoading } from "../loader";
import { useNavigate } from "react-router-dom";
export const UserProfileContext = createContext();

export const UserProfileProvider = ({ children }) => {
    const { REACT_APP_API_ENDPOINT, REACT_APP_APIGEE } = process.env;
    const [userProfile, setUserProfile] = useState(null);
    const userSelectedLanguage = localStorage.getItem("userSelLang");
    const [loading, setLoading] = useState(true);
    const { t, i18n } = useTranslation();
    const { showLoader, hideLoader } = useLoading();
    const navigate = useNavigate();

    useEffect(() => {
        var gpid;
        const data = JSON.parse(localStorage.getItem("okta-token-storage"));
        if (!gpid && data?.accessToken?.claims?.gpid) {
            gpid = data?.accessToken?.claims?.gpid
        }
        if (!gpid && window?.location?.hostname?.includes("localhost")) {
            gpid = "73120677"
        }
        if (gpid) {
            showLoader();
            const fetchUserProfile = async () => {
                var data;
                let expInDays;
                try {
                    const response = await axios.post(REACT_APP_API_ENDPOINT + "user/profile-details", {
                        GPID: gpid,
                    });
                    
                    if (response?.data) {
                        response['data']['profileDetails']['preferredLanguage'] = response?.data?.profileDetails?.preferredLanguage ? response?.data?.profileDetails?.preferredLanguage?.replace('-', '_') : null;
                        response['data']['profileDetails']['preferredLanguage'] = response?.data?.profileDetails?.preferredLanguage || "en_US";
                        data = {...response?.data?.profileDetails, appRecommendation: {...response?.data?.appRecommendation}};
                                                
                        //start outage
                        const rawSystems = Array.isArray(data?.systemsUnderMaintenance)
                        ? data.systemsUnderMaintenance
                        : [];
                        
                        const normalizedSet = new Set(
                            rawSystems
                            .filter((x) => typeof x === "string")
                            .map((x) => x.trim().toLowerCase())
                        );
                        
                        const SYSTEM_ALIASES = {
                            myidM: ["myidm", "myidm apps", "myidm services", "myidM".toLowerCase()],
                            SSO: ["sso", "sso apps", "single sign on"],
                            pepAGM: ["pepagm", "pep agm"],
                            PKI: ["pki", "public key infrastructure"],
                            myPAM: ["mypam", "my pam", "pam"],
                            DS: ["ds", "directory services", "directory"],
                            CIAM: ["ciam", "customer identity and access management"],
                        };
                        
                        const systemsStatus = Object.fromEntries(
                            Object.entries(SYSTEM_ALIASES).map(([key, aliases]) => [
                            key,
                            aliases.some((alias) => normalizedSet.has(alias)),
                            ])
                        );
  
                        data.systemsStatus = systemsStatus;
                        //end Outage
                        expInDays = data?.pwdExpInDays;
                        setUserProfile(data);
                        setLoading(false);
                        sessionStorage.setItem("codeCheck", `${data?.email}`.toLocaleLowerCase().includes("contractor") ? "0" : "1")
                       
                        try {
                            const languageFromProfile = data?.preferredLanguage?.split("_")[0];
                            const langToUse = userSelectedLanguage || languageFromProfile;
                            i18n.changeLanguage(langToUse || "en");
                            document.body.setAttribute("data-lang", langToUse?.split('_')[0]);
                            localStorage.setItem("lang", langToUse);
                            // window.location.reload();
                            console.warn(
                                " |> - User Default language from API",
                                langToUse
                            );
                        } catch (e) {
                            const data = {
                                "profileDetails": {
                                    "preferredLanguage": "en_US"
                                },
                            }
                            // localStorage.setItem("roles", null);
                            let langFromProfile = data?.profileDetails?.preferredLanguage || "en_US";
                            langFromProfile = langFromProfile.split("_")[0];
                            const langToUse = userSelectedLanguage || langFromProfile;
                            i18n.changeLanguage(langToUse || "en");
                            document.body.setAttribute("data-lang", langToUse?.split('_')[0]);
                            localStorage.setItem("lang", langToUse);
                            setUserProfile(data.profileDetails);
                            console.warn(
                                " |> - User Default language API - Error - Default EN"
                            );
                        }
                        setLoading(false);
                        hideLoader();
                        if(window.location.pathname.includes("authenticate")){
                            navigate("/home")
                        }
                    }
                    else {
                        hideLoader();
                        const data = {
                            "profileDetails": {
                                "preferredLanguage": "en_US"
                            },
                            pepappiamcentralroles: []//['["chatBot", "powerBI", "isApprovals", "iChangePassword", "betaFeatureName"]']
                        }
                        
                        let langFromProfile = data?.profileDetails?.preferredLanguage || "en_US";
                        langFromProfile = langFromProfile.split("_")[0];
                        const langToUse = userSelectedLanguage || langFromProfile;
                        i18n.changeLanguage(langToUse || "en");
                        document.body.setAttribute("data-lang", langToUse?.split('_')[0]);
                        localStorage.setItem("lang", langToUse);
                        setUserProfile(data.profileDetails);
                    }
                } catch (error) {
                    hideLoader();
                    console.warn(
                        "***** Error thrown for the Access detail api ***** ",
                        error?.response?.data?.message
                    );
                    const data = {
                        "profileDetails": {                            
                            "preferredLanguage": "en_US",                            
                        },
                        "responseStatus": "Success",
                        "responseMessage": "",
                        "messageCode": 100
                    }
                    
                    let langFromProfile = data?.profileDetails?.preferredLanguage || "en_US";
                    langFromProfile = langFromProfile.split("_")[0];
                    const langToUse = userSelectedLanguage || langFromProfile;
                    localStorage.setItem("lang", langToUse);
                    setUserProfile(data.profileDetails);
                    setLoading(false);
                } finally {
                    setLoading(false);
                    hideLoader();
                    if(window?.location?.href?.includes?.("/authenticate")){
                        setTimeout(()=>{
                            navigate("/home")
                        },1000)
                    }
                }
                
            }
            fetchUserProfile();
        }
    }, []);

    return (
        <UserProfileContext.Provider value={{ userProfile, loading }}>
            {children}
        </UserProfileContext.Provider>
    );
};

// Custom Hook to use the User Profile
export const useUserProfile = () => {
    return useContext(UserProfileContext);
};
